import { Variable } from '~/packages/variable/variables.typing'
import { defineAction, enumerated, number, object, string } from '~/prix'
import expression from '~/prix/types/expression'
import { analysis } from '~/prix/types/presets/analysis'
import { assertions } from '~/prix/types/presets/assertions'
import { select } from '~/prix/types/presets/select'
import { childrenType, spaceForPoint } from '~/prix/types/presets/space'
import { timeForCurrentOnly } from '~/prix/types/presets/time'
import { variable } from '~/prix/types/presets/variable'
import kpiYearlyCumulativeStatsAction from './kpiYearlyCumulativeStats.action.json' assert { type: 'json' }
import getRecommendedCacheOptions from '~/utils/server/stats/getRecommendedCacheOptions'

const combinedShape = object({
  id: string().label('ID', 'Identificador', 'Código'),
  kpiId: number().label('ID do KPI'),
  kpiDescription: string().isOptional().label('Descrição do KPI'),
  year: number().label('Ano'),
  month: number().label('Mês'),
  monthDescription: string().label('Descrição do mês'),
  uf: enumerated({
    Brasil: 'Brasil',
    AC: 'Acre',
    AL: 'Alagoas',
    AP: 'Amapá',
    AM: 'Amazonas',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais',
    PA: 'Pará',
    PB: 'Paraíba',
    PR: 'Paraná',
    PE: 'Pernambuco',
    PI: 'Piauí',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul',
    RO: 'Rondônia',
    RR: 'Roraima',
    SC: 'Santa Catarina',
    SP: 'São Paulo',
    SE: 'Sergipe',
    TO: 'Tocantins',
  }).label('Unidade Federativa'),
  value: number().label('Valor'),
})
export const kpiYearlyCumulativeExpression = expression(combinedShape.shape)

export const kpiYearlyCumulativeVariable: Variable = {
  key: 'kpiYearlyCumulative',
  categoryKey: 'monitorPortfolio',
  categoryKeys: ['monitorPortfolio'],
  actionDefinitionKey: kpiYearlyCumulativeStatsAction.key,
  aggregationMode: 'mean',
  customValue: {
    type: 'expression',
    kind: 'function',
    name: 'argMax',
    arguments: [
      {
        type: 'expression',
        kind: 'property',
        property: 'value',
        literalType: 'number',
      },
      {
        type: 'expression',
        kind: 'binary',
        operator: '+',
        left: {
          type: 'expression',
          kind: 'binary',
          operator: '*',
          left: {
            type: 'expression',
            kind: 'function',
            name: 'cast',
            arguments: [
              {
                type: 'expression',
                kind: 'property',
                property: 'year',
                literalType: 'number',
              },
              {
                type: 'expression',
                kind: 'literal',
                value: 'Int32',
                literalType: 'string',
              },
            ],
          },
          right: {
            type: 'expression',
            kind: 'literal',
            value: 100,
            literalType: 'number',
          },
        },
        right: {
          type: 'expression',
          kind: 'property',
          property: 'month',
          literalType: 'number',
        },
      },
    ],
  },
  title: 'KPI acumulado anualmente',
  unitSingular: '',
  unitPlural: '',
  unitFormat: 'percentage',
  unitFormatSuffix: {
    percentage: '',
  },
  grammaticalGender: 'female',
  timeType: 'currentOnly',
  shape: combinedShape,
  betterDensity: 'more',
  relevance: 0.5,
  basicSelect: [],
  detailedSelect: [],
  filterableBy: undefined,
  compatibleChildrenTypes: ['country', 'state'],

  spaceAnalysis: undefined,

  // assertions: prepareAssertions(kpiYearlyCumulativeExpression),
}

const kpiYearlyCumulativeStatsDefinition = defineAction({
  ...kpiYearlyCumulativeStatsAction,
  input: object({
    variable,
    highlight: kpiYearlyCumulativeExpression.isOptional(),
    filter: kpiYearlyCumulativeExpression.isOptional(),
    space: spaceForPoint().isOptional(),
    time: timeForCurrentOnly().isOptional(),
    select: select(combinedShape),
    assertions,
    analysis,
  }),
  output: object({
    items: object({
      value: number(),
      geoId: string().isOptional(),
      geoType: childrenType.isOptional(),
    }),
  }),
  cache: getRecommendedCacheOptions,
})

export default kpiYearlyCumulativeStatsDefinition
